module.exports = __webpack_public_path__ + "img/department.71454fbd.svg";